import React, {useEffect} from "react";
import {FormattedMessage, useIntl} from "react-intl";
import {DisplayableDataset, DownloadableDataset} from "../../../logic/APITypes";

/**
 * A download button for dataset contents using an objectURL (potentially formatted).
 */
function TopicContentViewerDownloadBlob(props: {
  currentDataset:
    | ({type: "display"} & DisplayableDataset)
    | ({type: "download"} & DownloadableDataset);
  topicName: string;
  content: string;
}) {
  const intl = useIntl();

  const objectURL =
    props.currentDataset.type === "download"
      ? window.URL.createObjectURL(
          new Blob(
            [
              new Uint8Array(
                atob(props.content)
                  .split("")
                  .map((char) => char.charCodeAt(0)),
              ),
            ],
            {type: "application/octet-stream"},
          ),
        )
      : window.URL.createObjectURL(
          new Blob([props.content], {
            type: props.currentDataset.mime_type,
          }),
        );

  useEffect(() => {
    return () => {
      if (objectURL) window.URL.revokeObjectURL(objectURL);
    };
  });

  return (
    <a
      id="topicContentViewerDownloadLink"
      className={
        "topicContentViewerDownload styleLinkAsButton wide " +
        (props.currentDataset.type === "download" ? "primary" : "tertiary")
      }
      download={`${props.topicName}-${intl.formatDate(
        props.currentDataset.received_at,
        {timeStyle: "medium", dateStyle: "short"},
      )}`.replace(/[/\\:*?"<>.]/g, "_")}
      href={objectURL}
    >
      <FormattedMessage id="topicContentViewer.controls.download" />
    </a>
  );
}

export {TopicContentViewerDownloadBlob};
